import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Zap, Wifi, Layers } from 'lucide-react';
export function HardwareSlide() {
  const features = [{
    icon: <Zap className="w-6 h-6 text-yellow-400" data-id="element-29" />,
    title: 'Direct Meter Connection',
    desc: 'Connects directly to the digital energy meter for real-time data.'
  }, {
    icon: <Layers className="w-6 h-6 text-[#00d8a8]" data-id="element-30" />,
    title: 'Universal Compatibility',
    desc: 'One device for all charger OEMs. Streamlines technician education.'
  }, {
    icon: <Wifi className="w-6 h-6 text-[#00d8a8]" data-id="element-31" />,
    title: 'Cloud Optimization',
    desc: 'Enables load balancing and energy optimization via the cloud.'
  }, {
    icon: <Cpu className="w-6 h-6 text-purple-400" data-id="element-32" />,
    title: 'Simplified Install',
    desc: 'Eliminates need for extra cabling and OEM-specific energy meters.'
  }];
  return <div className="h-full w-full flex flex-col md:flex-row items-start md:items-center md:justify-center px-4 md:px-16 bg-[#11166b] gap-8 md:gap-12 overflow-y-auto md:overflow-hidden py-16 md:py-0" data-id="element-33">
      <div className="flex-1 max-w-xl w-full mt-4 md:mt-0" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8 md:mb-12" data-id="element-35">
          <div className="inline-flex items-center justify-center p-3 bg-[#00d8a8]/10 rounded-xl mb-4 md:mb-6" data-id="element-36">
            <Cpu className="w-8 h-8 md:w-10 md:h-10 text-[#00d8a8]" data-id="element-37" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-38">
            Plug-and-Play Hardware
          </h2>
          <p className="text-base md:text-xl text-slate-300" data-id="element-39">
            A unified hardware layer that simplifies your entire installation
            workflow. The perfect tool for new installations, while existing
            installations can also benefit from our ecosystem without requiring
            a dongle.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-40">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + idx * 0.1
        }} className="flex items-start gap-3 p-4 rounded-xl bg-[#0d1155] border border-[#1a2080]" data-id="element-41">
              <div className="p-2 rounded-lg bg-[#11166b] border border-[#1a2080]" data-id="element-42">
                {feature.icon}
              </div>
              <div data-id="element-43">
                <h3 className="text-sm font-bold text-white mb-1" data-id="element-44">
                  {feature.title}
                </h3>
                <p className="text-slate-300 text-xs leading-relaxed" data-id="element-45">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      x: 50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="flex-1 flex justify-center items-center w-full pb-24 md:pb-0" data-id="element-46">
        <div className="relative max-w-xs md:max-w-lg" data-id="element-47">
          <div className="absolute inset-0 bg-[#00d8a8]/20 blur-3xl rounded-full" data-id="element-48" />
          <img src="https://cdn.magicpatterns.com/uploads/eLvXJSsZ9JqLfBo2tewicv/1000052439.png" alt="Plug-and-Play Hardware Device" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-49" />
        </div>
      </motion.div>
    </div>;
}